<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_5"></a><strong>This one’s for Meridith<br/>and our friends Horace,<br/>Wyatt, and Brown</strong>.</p>
<p class="noindent"><a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?37316e73